import { Flex } from '@teamsparta/stack-flex';
import Image from 'next/image';

import type { ContributionInfoResponseDto } from '@/api/campaign/grass/grass.dto';
import Only from '@/components/common/Only';
import { shareTwitter } from '@/lib/utils/businessLogics/graduate';

import { Card } from '../../shared/Card/template';
import { CardBackground } from '../../shared/CardBackground/template';
import { getRankStyle } from './data';
import { shareInstagram, shareKakao, useKeepCommitLogic } from './logic';
import * as S from './style';

interface KeepCommitProps {
  contributionData: ContributionInfoResponseDto;
}

export function KeepCommit({ contributionData }: KeepCommitProps) {
  const { currentUrl, handleClickContentCopy, parseTopThreeContributionData } =
    useKeepCommitLogic(contributionData);

  return (
    <S.Wrapper>
      <Flex.Column
        justify='center'
        align='center'
        gap='60px'
        style={{
          maxWidth: '500px',
          padding: '80px 16px',
          alignSelf: 'stretch',
          margin: '0 auto',
        }}
      >
        <Flex.Column
          align='center'
          gap='40px'
          style={{ alignSelf: 'stretch', margin: '0 auto', width: '100%' }}
        >
          <Flex.Column align='center' gap='20px'>
            <Only.Mobile>
              <S.ImageWrapper>
                <Image
                  src='/images/campaign/campaign_keep_commit.png'
                  alt='keep_commit_keep_contribution'
                  fill
                  style={{
                    objectFit: 'contain',
                  }}
                />
              </S.ImageWrapper>
            </Only.Mobile>
            <Only.Desktop>
              <S.ImageDesktopWrapper>
                <Image
                  src='/images/campaign/campaign_keep_commit.png'
                  alt='keep_commit_keep_contribution'
                  fill
                  style={{
                    objectFit: 'contain',
                  }}
                />
              </S.ImageDesktopWrapper>
            </Only.Desktop>
            <S.Text>
              {
                '여러분이 성장하는 만큼, 세상도 성장합니다.\n자긍심을 갖고 전진해 나가시길 항해99가 응원할게요.'
              }
            </S.Text>
          </Flex.Column>

          <S.GrassHallWrapper>
            {contributionData?.recentContributionInfos && (
              <Card title='잔디의 전당' titleBackground='lg' textAlign='center'>
                <S.GrassHallText>실시간 참여 현황</S.GrassHallText>
                <S.GrassHallGrid>
                  {contributionData?.recentContributionInfos.map(
                    (item, index) => (
                      <S.GrassHallItem key={index}>
                        <S.GrassHallItemCountContainer>
                          <S.TextCountNumber>
                            {item.totalContributionsIn2024}
                          </S.TextCountNumber>
                          <S.TextCountKorea>개</S.TextCountKorea>
                        </S.GrassHallItemCountContainer>
                        <Flex
                          justify='center'
                          align='center'
                          gap='1px'
                          style={{ height: '16px' }}
                        >
                          <S.TextName>{item.gitHubUsername}</S.TextName>
                          <S.TextName>님</S.TextName>
                        </Flex>
                      </S.GrassHallItem>
                    ),
                  )}
                </S.GrassHallGrid>
              </Card>
            )}
            {contributionData?.topThreeContributionInfos && (
              <CardBackground textAlign='center'>
                <S.GrassHallText>잔디 기부 랭킹 TOP3</S.GrassHallText>
                {parseTopThreeContributionData?.map((item, index) => (
                  <Flex.Column
                    key={index}
                    align='start'
                    gap='1px'
                    style={{
                      width: '100%',
                    }}
                  >
                    <Flex.Row
                      justify='center'
                      align='center'
                      gap='4px'
                      style={{
                        padding: '4px 10px',
                        alignSelf: 'stretch',
                        borderRadius: '4px',
                        ...getRankStyle(index),
                      }}
                    >
                      <S.RankCountTextNumber>
                        {index + 1}등
                      </S.RankCountTextNumber>
                      <Flex.Row gap='1px'>
                        <S.RankCountTextNumber>
                          {item.totalContributionsIn2024}
                        </S.RankCountTextNumber>
                        <S.RankCountTextKorea>개</S.RankCountTextKorea>
                      </Flex.Row>
                    </Flex.Row>
                    <Flex
                      justify='center'
                      align='center'
                      style={{ width: '100%' }}
                    >
                      <S.RankTextName>{item.gitHubUsername}</S.RankTextName>
                    </Flex>
                  </Flex.Column>
                ))}
              </CardBackground>
            )}
          </S.GrassHallWrapper>
        </Flex.Column>

        <Flex.Column justify='center' align='center' gap='20px'>
          <S.ShareTitle>
            {'SNS 공유를 통해\n개발자의 힘을 모아보아요'}
          </S.ShareTitle>
          <Flex align='center' gap='12px'>
            <S.ShareIconWrapper>
              <Image
                src='/images/campaign/campaign_share_kakao.svg'
                alt='share_kakao'
                width={32}
                height={32}
                onClick={() => shareKakao(currentUrl, '공유하기')}
              />
            </S.ShareIconWrapper>
            <S.ShareIconWrapper>
              <Image
                src='/images/campaign/campaign_share_instagram.svg'
                alt='share_instagram'
                width={32}
                height={32}
                onClick={shareInstagram}
              />
            </S.ShareIconWrapper>
            <S.ShareIconWrapper>
              <Image
                src='/images/campaign/campaign_share_x.svg'
                alt='share_x'
                width={32}
                height={32}
                onClick={() => shareTwitter(currentUrl)}
              />
            </S.ShareIconWrapper>
            <S.ShareIconWrapper>
              <Image
                src='/images/campaign/campaign_share_copy_link.svg'
                alt='share_copy_link'
                width={32}
                height={32}
                onClick={handleClickContentCopy}
              />
            </S.ShareIconWrapper>
          </Flex>
        </Flex.Column>
      </Flex.Column>
    </S.Wrapper>
  );
}
